import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'gray';
  size?: 'sm' | 'md';
  className?: string;
}

const inlineStyles: Partial<Record<BadgeProps['variant'] & string, React.CSSProperties>> = {
  success: { backgroundColor: '#10B98114', color: '#10B981', border: '1px solid #10B9811A' },
  warning: { backgroundColor: '#FEF3C780', color: '#92400E', border: '1px solid #92400E1A' },
};

export function Badge({ children, variant = 'primary', size = 'md', className = '' }: BadgeProps) {
  const variants = {
    primary: 'bg-hprimary-100 text-hprimary-700 border-hprimary-200',
    secondary: 'bg-hsecondary-100 text-hsecondary-700 border-hsecondary-200',
    success: '',
    warning: '',
    danger: 'bg-red-100 text-red-700 border-red-200',
    gray: 'bg-gray-100 text-gray-700 border-gray-200',
  };

  const sizes = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
  };

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full border ${variants[variant]} ${sizes[size]} ${className}`}
      style={inlineStyles[variant]}
    >
      {children}
    </span>
  );
}

